module.exports = __webpack_public_path__ + "static/media/lab smart.1ddec626.svg";